import { Component, inject, Input } from '@angular/core';
import { SellerInterface } from '@interfaces/artisan/seller_interface';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { MenuActions } from '../../../states/menu_actions';

@Component({
  selector: 'ln-seller-card',
  imports: [LnImageFrameComponent],
  templateUrl: './seller-card.component.html',
  styleUrl: './seller-card.component.css',
})
export class SellerCardComponent {
  @Input({ required: true }) seller!: SellerInterface;
  private menuActions = inject(MenuActions);

  onClick() {
    this.menuActions.navigateToArtisanProfile(this.seller.id);
  }
}
